import { type OccupationArea } from '@models/OccupationArea';
import BackendClient from '@services/utils/BackendClient';

import { type IGetAllOccupationAreasOutputData } from './dtos/getAllOccupationAreas/OutputData';
import { type IOccupationAreaRepository } from './IOccupationAreaRepository';

interface IBackendListMedicalFieldsResponse {
  list: {
    description: string;
    id: number;
  }[];
}

class OccupationAreaService implements IOccupationAreaRepository {
  public async getAll(): Promise<IGetAllOccupationAreasOutputData> {
    const response = await BackendClient.get<IBackendListMedicalFieldsResponse>(
      {
        path: 'medical-fields',
      },
    );
    const output: IGetAllOccupationAreasOutputData = {
      list: response.data.list.map((item) => {
        const occupationArea: OccupationArea = {
          id: item.id,
          name: item.description,
        };
        return occupationArea;
      }),
    };
    return output;
  }
}

export default new OccupationAreaService();
